import { render } from "./Main.vue?vue&type=template&id=439e23bc&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=439e23bc&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=1&id=439e23bc&scope=true&lang=css"
script.render = render
script.__scopeId = "data-v-439e23bc"

export default script